<template>
    <div class="text-center">
        <v-progress-circular
            v-bind="$attrs"
            indeterminate
            :color="$attrs.color ? $attrs.color : '#184DB4'"
            :width="$attrs.width ? $attrs.width : 2" />
    </div>
</template>

<script>
export default {
    name: 'DataLoading',
    inheritsAttribute: true,
};
</script>
